import * as React from 'react';
import { useSelector } from 'react-redux';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { RootState } from 'redux/store';
import Colors from 'constants/colors';
import { formatAmount } from 'utils/helpers';

interface WalletCardItem {
    title: string;
    icon: React.ReactElement | string;
    description: string;
    label: string;
}

interface WalletCardProp {
    onClickNavigation: Function;
    item: WalletCardItem;
}

const CardContainer = styled(Card)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: '#F2F2F6',
    padding: 12,
    margin: 12,
    marginTop: 23,
});

export default function WalletCard({ item, onClickNavigation }: WalletCardProp) {
    const { title, description, label, icon } = item || {};
    const { balance, isMerchant } = useSelector((state: RootState) => ({
        balance: state.wallet.merchantBalance.balance,
        isMerchant: state.auth.isMerchant,
    }));
    if (!isMerchant && label === 'wallet') return null;
    return (
        <CardContainer>
            {/* Card main content */}
            <div onClick={() => onClickNavigation(title)} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                {/* Card image */}
                <CardMedia
                    sx={{ width: { xs: 150, sm: 80 }, height: 80, alignItems: 'center', justifyContent: 'center', display: 'flex' }}
                    title={title} // Use the provided title instead of hardcoded
                >
                    <IconButton sx={{ color: Colors.iconcolor, justifyContent: 'center' }}>{icon}</IconButton>
                </CardMedia>

                {/* Card text content */}
                <CardContent sx={{ flex: { sm: 1 } }}>
                    <Typography sx={{ fontSize: 18, fontWeight: 300 }} variant="h5" component="div">
                        {title}
                    </Typography>
                    {label === 'wallet' && (
                        <Typography variant="body2" style={{ color: '#1F2937', fontWeight: 400, fontSize: 18 }}>
                            {balance && formatAmount(balance)}
                        </Typography>
                    )}
                    <Typography sx={{ fontSize: 12, fontWeight: 400 }} variant="body2" color="text.secondary">
                        {description}
                    </Typography>
                </CardContent>
                {/* Card side content */}
                <IconButton sx={{ alignSelf: 'center', color: '#1F2937' }}>
                    <ArrowForwardIosIcon />
                </IconButton>
            </div>

            {/* Card action button */}
        </CardContainer>
    );
}
